<template>
  <media-gesture
    class="absolute inset-0 z-0 block h-full w-full"
    event="pointerup"
    action="toggle:paused"
  />
  <media-gesture
    class="absolute inset-0 z-0 block h-full w-full"
    event="touchend"
    action="toggle:paused"
  />
  <media-gesture
    class="absolute inset-0 z-0 hidden h-full w-full md:block"
    event="dblpointerup"
    action="toggle:fullscreen"
  />
  <media-gesture
    class="absolute left-0 z-10 block h-full w-1/5"
    event="dblpointerup"
    action="seek:-10"
  />
  <media-gesture
    class="absolute top-0 right-0 z-10 block h-full w-1/5"
    event="dblpointerup"
    action="seek:10"
  />
</template>
